export default {
  install(Vue, options) {
    const store = options.store;
    const WOGAA_TRACKING_ID =
      store.state.config.configurationData.wogaaTrackingId.eServices;

    const isWogaaAvailable = () => (window.wogaaCustom ? true : false);

    Vue.prototype.$wogaa = {
      startTransactionalService: (trackingId = WOGAA_TRACKING_ID) => {
        if (isWogaaAvailable()) {
          window.wogaaCustom.startTransactionalService(trackingId);
        }
      },

      completeTransactionalService: (trackingId = WOGAA_TRACKING_ID) => {
        if (isWogaaAvailable()) {
          window.wogaaCustom.completeTransactionalService(trackingId);
        }
      }
    };
  }
};
